import React, { useState, useEffect, useContext, use } from "react";
import { motion } from "framer-motion";
import "../styles/Setting.css";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContext"; // اتصال به کانتکست


function Setting() {
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const [profileImage, setProfileImage] = useState(null);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [currentUsername, setCurrentUsername] = useState(""); // مقدار پیش‌فرض
  const [newUsername, setNewUsername] = useState("");
  const navigate = useNavigate();
  const { user, setUser } = useContext(UserContext); // دریافت کانتکست
  const [isAdmin, setIsAdmin] = useState(false);
  const [dragging, setDragging] = useState(false);


  useEffect(() => {
    // مقدار اولیه را از کانتکست تنظیم کنید
    if (user?.username) {
      setCurrentUsername(user.username);
    }
  }, []);
  // ✅ هندل انتخاب عکس پروفایل
  const handleProfileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfileImage(URL.createObjectURL(file));
    }
  };
  const handleDragOver = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setDragging(false);
    const file = event.dataTransfer.files[0];

    if (file) {
      setProfileImage(URL.createObjectURL(file));
      document.getElementById("profilePic").files = event.dataTransfer.files;
    }
  };
  // ✅ هندل تغییر رمز عبور
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const logout = async () => {
    localStorage.removeItem("userToken"); // ❌ توکن رو پاک کن
    setUser(null); // ❌ کاربر رو از کانتکست پاک کن
    navigate("/login"); // ⬅️ انتقال به صفحه لاگین
  };

  const changeImage = async () => {
    const fileInput = document.getElementById("profilePic").files[0];
    if (!fileInput) {
      alert("Please select a profile image before confirming.");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileInput);

    try {
      const response = await fetch(`${API_BASE_URL}/User/upload-profile-image`, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${localStorage.getItem("userToken")}`,
        },
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage || "Failed to upload image.");
      }

      const result = await response.json();
      alert("Profile image updated successfully.");
      
      // به‌روزرسانی تصویر در کانتکست
      setUser((prevUser) => ({
        ...prevUser,
        avatar: `${API_BASE_URL}` + result.imageUrl,
      }));

      setProfileImage(null);
    } catch (error) {
      console.error("Error uploading image:", error);
      alert(error.message);
    }
  };
  const handleChangePassword = async () => {
    const oldPassword = document.querySelector("input[placeholder='Current Password']").value;
    const newPassword = document.querySelector("input[placeholder='New Password']").value;
    const confirmNewPassword = document.querySelector("input[placeholder='Confirm New Password']").value;
  
    // بررسی اینکه رمز عبور جدید و تأیید آن یکسان باشد
    if (newPassword !== confirmNewPassword) {
      alert("New password and its confirmation do not match!");
      return;
    }
  
    try {
      const token = localStorage.getItem("userToken");
  
      const response = await fetch(`${API_BASE_URL}/Auth/changepassword`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ارسال توکن برای احراز هویت
        },
        body: JSON.stringify({
          OldPassword: oldPassword,
          NewPassword: newPassword,
        }), // ارسال اطلاعات در قالب مدل مورد انتظار سرور
      });
  
      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage || "Failed to change password.");
      }
  
      alert("Password changed successfully!");
      // پاک کردن ورودی‌ها
      document.querySelector("input[placeholder='Current Password']").value = "";
      document.querySelector("input[placeholder='New Password']").value = "";
      document.querySelector("input[placeholder='Confirm New Password']").value = "";
    } catch (error) {
      console.error("Error changing password:", error);
      alert(error.message);
    }
  };
  const handleChangeUsername = async () => {
    if (currentUsername.trim() === "") {
      alert("Username cannot be empty!");
      return;
    }
  
    try {
      const token = localStorage.getItem("userToken");
  
      const response = await fetch(`${API_BASE_URL}/User/changeusername`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`, // ارسال توکن برای احراز هویت
        },
        body: JSON.stringify({
          newUsername: currentUsername, // ارسال نام کاربری جدید طبق مدل سمت سرور
        }),
      });
  
      if (!response.ok) {
        const errorMessage = await response.text();
        throw new Error(errorMessage || "Failed to change username.");
      }
  
      const result = await response.json();
  
      // به‌روزرسانی نام کاربری در رابط کاربری
      setUser((prevUser) => ({
        ...prevUser,
        username: currentUsername,
      }));
  
      alert("Username changed successfully!");
    } catch (error) {
      console.error("Error changing username:", error);
      alert(error.message);
    }
  };
  
  return (
    <motion.div
      className="setting-page"
      initial={{ opacity: 0, x: -30 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.9, ease: "easeOut" }}
    >
      <h1>Settings</h1>

      {/* ✅ تغییر عکس پروفایل */}
      <section className="profile-section">
        <h2>Change Profile Picture</h2>
        <div className="profile-upload">
          <input type="file" id="profilePic" accept="image/*" onChange={handleProfileChange} hidden />
          <label
            htmlFor="profilePic"
            className={`upload-box ${dragging ? "dragging" : ""}`}
            onDragOver={handleDragOver}
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}
          >
            {profileImage ? <img src={profileImage} alt="Profile Preview" className="profile-preview" /> : "Drag & Drop or Click to Upload"}
          </label>
        </div>
        <div className="buttons">
          <button className="confirm-btn" onClick={changeImage}>Confirm</button>
          <button className="cancel-btn" onClick={() => setProfileImage(null)}>Cancel</button>
        </div>
      </section>

      {/* ✅ تغییر رمز عبور */}
      <section className="password-section">
        <h2>Change Password</h2>
        <input type={passwordVisible ? "text" : "password"} placeholder="Current Password" />
        <input type={passwordVisible ? "text" : "password"} placeholder="New Password" />
        <input type={passwordVisible ? "text" : "password"} placeholder="Confirm New Password" />
        <label>
          <input type="checkbox" onChange={togglePasswordVisibility} /> Show Password
        </label>
        <div className="buttons">
          <button className="confirm-btn" onClick={handleChangePassword}>Confirm</button>
          <button className="cancel-btn">Cancel</button>
        </div>
      </section>

      {/* ✅ تغییر یوزرنیم */}
      <section className="username-section">
        <h2>Change Username</h2>
        <input type="text" value={currentUsername} onChange={(e) => setCurrentUsername(e.target.value)} placeholder="Enter your username"/>
        <div className="buttons">
          <button className="confirm-btn" onClick={handleChangeUsername}>Confirm</button>
          <button className="cancel-btn" onClick={() => setCurrentUsername("YourUsername")}>Cancel</button>
        </div>
      </section>
      {(user != null && user.admin == true || user != null && user.isAdmin == true) && (
        <section className="admin-panel-section">
          <button className="confirm-btn" onClick={() => navigate("/admin/users")}>Go to Admin Panel</button>
        </section>
      )}
      <section className="logout-section">
        <button className="cancel-btn" onClick={logout}>Logout</button>
      </section>
    </motion.div>
  );
}

export default Setting;
